export enum DiscountType {
  PERCENT = 'PERCENT',
  AMD = 'AMD'
}
